import { forwardRef, useCallback, useState } from 'react';
import { DownlaodFileIcon, UploadIcon } from '../../helpers/icons';
import {
  downloadFileFromURL,
  getAccessToken,
} from '../../helpers/functions';
import { useAuth } from '../../zustand';

// ['text/csv','image/png','image/jpeg','application/pdf','image/*']
// [ 'application/pdf', 'text/plain', 'application/msword','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','text/csv']
export const UploadFileCard = forwardRef(
  (
    {
      heading = 'Upload File',
      supportedFormatArray = ['csv', 'xlsx'],
      label,
      sampleFile = () => true,
      acceptFiles = '.csv',
      error,
      watch,
      setValue,
      percentage = 0,
      inProgress = false,
      downloadSampleApi = () => {},
      fileName,
      allowedFiles = [
        'text/csv',
        'image/png',
        'image/jpeg',
        'application/pdf',
        'image/*',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ],
      ...rest
    },
    ref,
  ) => {
    const text = error || label || '';
    const [isDragging, setIsDragging] = useState(false);
    const { state } = JSON.parse(getAccessToken()) || {};
    const data = useAuth.getState();
    const accessToken = state?.token || data?.token;

    const handleDragOver = useCallback((e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(true);
    }, []);

    const handleDragLeave = useCallback((e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
    }, []);

    const handleDrop = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        const files = e.dataTransfer.files;
        for (let i = 0; i < files.length; i++) {
          if (!supportedFormatArray.includes(files[i].name.split('.').at(-1))) {
            setValue(rest?.name, null, {
              shouldValidate: true,
            });
            return;
          }
        }
        setValue(rest?.name, e.dataTransfer.files, {
          shouldValidate: true,
        });
      }
    };
    const handleChange = (e) => {
      let file = e?.target.files[0];
      const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
      if (file) {
        if (file > maxSize) {
          // Toaster.error('File is too large. Maximum size is 5 MB.');
          alert('File is too large. Maximum size is 5 MB.');
          setValue(rest?.name, null, {
            shouldValidate: true,
          });
          return;
        } else if (!allowedFiles.includes(file.type)) {
          // Toaster.error('This file type is not allowed.');
          alert('This file type is not allowed.');
          setValue(rest?.name, null, {
            shouldValidate: true,
          });
          return;
        } else {
          setValue(rest?.name, file, {
            shouldValidate: true,
          });
        }
      }
    };
    return (
      <div className="d--flex w--full flex--column">
        <label
          className={`label--control font--sm font--500 m-b--sm
        ${error ? 'text--danger' : 'text--black'}
        `}
        >
          {text}
        </label>
        <label
          htmlFor={`${rest?.name}_upload_file`}
          className={`form--control w--full h-min--150 radius--sm p-l--md p-r--md border-full--black-200 d--flex gap--sm flex--column align-items--center justify-content--center position--relative ${isDragging ? 'o--sm' : ''}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <input
            {...rest}
            ref={ref}
            id={`${rest?.name}_upload_file`}
            type="file"
            className="w--full h--full top--0 bottom--0 left--0 right--0 position--absolute c--pointer"
            onChange={(e) => handleChange(e)}
            accept={acceptFiles}
            hidden
          />
          <div className="text--primary">
            <UploadIcon width={36} height={36} />
          </div>

          {/* {inProgress ? (
            <div
              className={
                inProgress
                  ? 'img-upload-overlay w--full h--full d--flex align-items--center justify-content--center radius-100'
                  : ''
              }
            >
              {inProgress ? (
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    style={{ width: `${percentage}%` }}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : ( */}
          <div className="text--primary font--sm">{heading}</div>
          {/* )} */}

          <div className="text--black-600 font--xs text--center">
            Supported format {supportedFormatArray.join(', ')}
          </div>
          <div className="font--sm text--danger">{watch(rest?.name)?.name}</div>
        </label>
        {sampleFile() && (
          <div
            className="d--flex gap--xs w--full align-items--center justify-content--end text--primary font--xs m-t--sm c--pointer"
            onClick={() => {
              const url = downloadSampleApi();
              downloadFileFromURL({
                url,
                fileName,
                token: accessToken,
              });
            }}
          >
            <DownlaodFileIcon width={18} height={18} />
            Sample File
          </div>
        )}
        {/* {sampleFile ? (
          <div
            className="d--flex gap--xs w--full align-items--center justify-content--end text--primary font--xs m-t--sm c--pointer"
            onClick={() => sampleFile && downloadFile(sampleFile)}
          >
            <DownlaodFileIcon width={18} height={18} />
            Sample File
          </div>
        ) : (
          <div
            className="d--flex gap--xs w--full align-items--center justify-content--end text--primary font--xs m-t--sm c--pointer"
            onClick={() => {
              const url = downloadSampleApi();
              downloadFileFromURL({
                url,
                fileName,
                token: accessToken,
              });
            }}
          >
            <DownlaodFileIcon width={18} height={18} />
            Sample File
          </div>
        )} */}
      </div>
    );
  },
);
